import React from "react";
import PropTypes from "prop-types";
import { RadioField } from "../../FormField";

const RadioButtonGroup = ({ groupNumber, questions, inputs, prefixes, data }) => (
  <React.Fragment>
    {questions.map((question, index) => {
      return (
        <tr key={index} style={index === questions.length - 1 ? { borderBottom: "1px solid" } : {}}>
          <td>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: 30 }}>{index === 0 && groupNumber}</td>
                  <td>{question}</td>
                </tr>
              </tbody>
            </table>
          </td>
          {prefixes.map(
            (prefix, pIndex) =>
              prefix && inputs[index] && typeof inputs[index] !== "string" ? (
                inputs[index]({ prefix })
              ) : (
                <React.Fragment key={pIndex + groupNumber}>
                  <td
                    style={{
                      textAlign: "center",
                      borderLeft: "1px solid",
                      background: prefix ? "#fff" : "#e9eaeb",
                    }}
                  >
                    {prefix &&
                      inputs[index] && (
                        <RadioField
                          name={`${prefix}${inputs[index]}`}
                          {...data[`${prefix}${inputs[index]}`]}
                          radioValue="Yes"
                        />
                      )}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid",
                      background: prefix ? "#fff" : "#e9eaeb",
                    }}
                  >
                    {prefix &&
                      inputs[index] && (
                        <RadioField
                          name={`${prefix}${inputs[index]}`}
                          {...data[`${prefix}${inputs[index]}`]}
                          radioValue="No"
                        />
                      )}
                  </td>
                </React.Fragment>
              )
          )}
        </tr>
      );
    })}
  </React.Fragment>
);

RadioButtonGroup.propTypes = {
  groupNumber: PropTypes.number,
  questions: PropTypes.arrayOf(PropTypes.node),
  inputs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.func])),
  prefixes: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.shape({}),
};

export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/common/RadioButtonGroup.js